import { Badge } from '@/components/ui/badge';
import type { ReceivingLineStatus } from '../../types';

interface ReceivingLineStatusBadgeProps {
  status: ReceivingLineStatus;
}

const statusConfig: Record<ReceivingLineStatus, { label: string; variant: 'default' | 'secondary' | 'outline' | 'destructive' }> = {
  pending: { label: 'Pending', variant: 'secondary' },
  partial: { label: 'Partial', variant: 'outline' },
  complete: { label: 'Complete', variant: 'default' },
  rejected: { label: 'Rejected', variant: 'destructive' },
};

export function ReceivingLineStatusBadge({ status }: ReceivingLineStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, variant: 'secondary' as const };

  const colorClasses: Record<ReceivingLineStatus, string> = {
    pending: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
    partial: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
    complete: 'bg-green-100 text-green-800 hover:bg-green-100',
    rejected: 'bg-red-100 text-red-800 hover:bg-red-100',
  };

  return (
    <Badge
      variant={config.variant}
      className={colorClasses[status]}
    >
      {config.label}
    </Badge>
  );
}
